import { createActions } from '@buildium/angularjs-core/dist/data';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { ProspectDetailsDto } from '@app/rental-prospects/data/dtos/prospect-details-dto';

const actions = {
    getRentalProspect: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/rentalProspect/:rentalProspectId`,
    }
};

export interface IRentalProspectSharedApi {
    getRentalProspect(params: { rentalProspectId: number }): Promise<ProspectDetailsDto>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function RentalProspectSharedApi(): IRentalProspectSharedApi {
    return createActions(actions);
}
